module.exports = __webpack_public_path__ + "static/media/I.b9a84084.jpg";